import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'countryFlag' })
export class CountryFlagPipe implements PipeTransform {
  transform(isoCode: string | null | undefined): string {
    if (!isoCode || isoCode.length < 2) return '';
    return [...isoCode.toUpperCase()]
      .map(char => String.fromCodePoint(0x1F1E6 + char.charCodeAt(0) - 65))
      .join('');
  }
}
